import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Form } from 'antd';
import { toString, forEach } from 'lodash';
import validator from 'validator';
import { connect } from 'react-redux';

import helpers from 'utils/helpers';
import { loginRequest, googleLoginRequest, loginAsRequest } from 'ducks/auth';
import {
  FormTitle,
  StyledInput,
  StyledPasswordInput,
  StyledFormItem,
  StyledButton,
} from 'components/Styled';

class Login extends Component {
  state = {
    email: '',
    password: '',
    t: () => {}
  };

  gtmEvents = {
    // reserve use
    // email: `Inputted Login Email`,
    // password: `Inputted Login Password`
  };

  handleTextInputChange = (value, name) => {
    this.setState({
      [name]: value
    });
  };

  handleTextInputBlur = name => {
    if (this.gtmEvents[name]) {
      window.dataLayer.push({
        event: this.gtmEvents[name],
        loginInput: toString(this.state[name])
      });
    }

    this.setState({
      [name + 'Status']: this.validateError(name) ? 'error' : '',
      [name + 'Help']: this.validateError(name)
    });
  };

  validateType = {
    email: 'email',
    password: 'password'
  };

  validate = () => {
    const fields = ['password', 'email'];

    const states = {};
    forEach(fields, field => {
      states[field + 'Changed'] = true;
      states[field + 'Status'] = this.validateError(field) ? 'error' : '';
      states[field + 'Help'] = this.validateError(field);
    });

    this.setState(states);

    for (var i = 0; i < fields.length; i++) {
      if (this.validateError(fields[i])) {
        return false;
      }
    }
    return true;
  };

  validateError = name => {
    // let patterns;
    const value = toString(this.state[name]);

    switch (this.validateType[name]) {
      case 'password':
        if (value === '') {
          return `auth.err_msg.${name}.empty`;
        }
        return null;
      case 'email':
        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `auth.err_msg.${name}.empty`;
        }
        if (!validator.isEmail(value)) {
          return `auth.err_msg.${name}.format`;
        }

        return null;
      default:
        return null;
    }
  };

  handleAction = () => {
    if (!this.validate()) {
      return helpers.scrollToError();
    }

    this.props.loginRequest({
      email: this.state.email,
      password: this.state.password
    });
  };

  onSignIn = googleUser => {
    this.props.googleLoginRequest(googleUser);
  };

  toRegister = () => {
    window.location.href = 'https://ship.spaceshipapp.com/signup';
  };

  toForgotPassword = () => {
    this.props.onPageChange('forgot-password');
  };

  componentDidMount() {
    window.dataLayer.push({
      event: 'Land Login'
    });

    if (this.props.email) {
      this.setState({
        email: this.props.email
      });
    }

    const params = new URLSearchParams(window.location.search);
    const access = params.get('access');
    if (access) {
      console.log(access);
      this.props.loginAsRequest({
        access: access
      });
    }
  }

  render() {
    return (
      <div
        style={{
          backgroundColor: '#fafafa',
          minHeight: '100%'
        }}>
        <div style={{ padding: '50px 0 45px', textAlign: 'center' }}>
          <div style={{ fontSize: '20px', fontWeight: 700 }}>
            {this.props.t('auth.login.login')}
          </div>
          <div style={{ fontSize: '12px', paddingTop: '5px' }}>
            {this.props.t('auth.login.login_text')}
          </div>
        </div>
        <Form>
          <div style={{ padding: '' }}>
            <FormTitle>{this.props.t('auth.login.email')}</FormTitle>
            <StyledFormItem
              validateStatus={this.state['emailStatus'] || ''}
              help={this.props.t(this.state['emailHelp'])}>
              <StyledInput
                size="large"
                value={this.state['email']}
                onChange={e => {
                  this.handleTextInputChange(e.target.value, 'email');
                }}
                onBlur={e => {
                  this.handleTextInputBlur('email');
                }}
              />
            </StyledFormItem>
            <FormTitle style={{ paddingTop: '20px' }}>
              {this.props.t('auth.login.password')}
            </FormTitle>
            <StyledFormItem
              validateStatus={this.state['passwordStatus'] || ''}
              help={this.props.t(this.state['passwordHelp'])}>
              <StyledPasswordInput
                size="large"
                value={this.state['password']}
                onChange={e => {
                  this.handleTextInputChange(e.target.value, 'password');
                }}
                onBlur={e => {
                  this.handleTextInputBlur('password');
                }}
              />
            </StyledFormItem>
          </div>
          <div style={{ padding: '15px 0' }}>
            <StyledButton
              onClick={this.handleAction}
              type="primary"
              loading={this.props.loading}
              htmlType="submit"
              shadow="true"
              block>
              {this.props.t('auth.login.login')}
            </StyledButton>
          </div>
          <div style={{ paddingTop: '65px', textAlign: 'center' }}>
            <span
              style={{
                color: '#9900A5',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}
              onClick={this.toRegister}>
              {this.props.t('auth.login.free_register')}
            </span>
            <span style={{ padding: '0 10px' }}>|</span>
            <span
              style={{
                color: '#9900A5',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}
              onClick={this.toForgotPassword}>
              {this.props.t('auth.login.forget_password')}
            </span>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: !!state.auth.loading,
    loginSuccess: !!state.auth.loginSuccess
  };
};

const mapDispatchToProps = {
  loginRequest,
  googleLoginRequest,
  loginAsRequest
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Login)
);
